import React from "react";
import EdelLogoCenter from "../../UI/EdelLogoCenter/EdelLogoCenter";
import "./Layout.scss";
import { useHistory, useLocation } from "react-router-dom";
import {
  parseQuery,
  redirectToEntryPoint,
  clientPartialDetailsToStore,
  setStageData,
  queryParameter,
} from "../../Services/globalService";
import { containerUrl, dashboardUrl, statusUrl } from "../../utils/constants";
import GlobalStore from "../../store/globalStore";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";
import { checkModuleCompleteness } from "../../Profile/ProfileNavBar/ProfileNavBar";
import useQuery from "../../../customHooks/useQuery";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { AGetClientDetailsByPan } from "../../Services/registration/panDobApiService";
import { AGetClientAccountCode } from "../../Services/dashboard/eSignApiServices";

export interface RegistrationLayoutProps {
  isSubmissionRoute?: boolean;
  supportNeeded?: boolean;
  headerLogoClassName?: string;
  regOutNewClassName?: string;
  skipOption?: boolean;
}
export interface IEsignObject {
  Applicationid: string;
  AccountCategory: number;
  isEsign: string;
  isPOA: boolean;
  EsignDocType: number;
  UserId?: number;
  PanNo?: string;
}

export interface IDropoffObject {
  Applicationid: string;
  Pan: string;
  Ac: string;
  uid: any;
}
const RegistrationLayout: React.FC<RegistrationLayoutProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const quryMainParams = queryParameter(location.search);
  let id: any = quryMainParams.get("id");
  let skipUrl = quryMainParams.get("skipUrl");
  let type: any = quryMainParams.get("type");
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);
  if (
    props.isSubmissionRoute !== undefined &&
    props?.isSubmissionRoute !== null &&
    props?.isSubmissionRoute
  ) {
    props.isSubmissionRoute && clientPartialDetailsToStore();
  }
  function searchByLeadId(res: any, queryObject?: IEsignObject, skipNavigate?: boolean) {
    if (!res || res.error) {
      // setErrCode("119 - Error in fetching Client details from our system.");
      // setErrCode(res.error);
      // setIsLoading(false);
    } else {
      if (res.data && res.data != null) {
        GlobalStore.token = res.data.Token;
        GlobalStore.applicationID = res.data.ApplicatoinId;
        GlobalStore.accountcategory = res.data.AccountCategory;
        GlobalStore.personaldetails.pan = res.data.PAN;
        GlobalStore.leadId = res.data.LeadId;
        GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.leadID = res.data.LeadId;
        clientPartialDetails_ao.pan = res.data?.PAN;
        clientPartialDetails_ao.clientPrimaryDetailId =
          res.data.ClientPrimaryDetailId;
        clientPartialDetails_ao.applicationId = res.data.ApplicatoinId;
        clientPartialDetails_ao.accountcategory = res.data.AccountCategory;
        clientPartialDetails_ao.token = res.data.Token;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        if (
          queryObject !== undefined &&
          queryObject !== null &&
          queryObject?.isEsign !== null &&
          queryObject?.isEsign !== undefined &&
          queryObject?.isEsign !== "" &&
          queryObject?.isEsign === "K"
        ) {
          setTimeout(() => {
            AGetStageCompletionStatus(
              (res: any) => getClientStageDetails(res),
              queryObject?.Applicationid
            );
          }, 1000);
        } else if (!skipNavigate) {
          history.push(statusUrl.statusContinue);
        } else if (skipNavigate) {
          AGetStageCompletionStatus(
            (res: any) => getClientStageDetailsElog(res),
            GlobalStore.applicationID
          );
        }
      } else {
        // setErrCode(res.error);
        // setIsLoading(false);
      }
    }
  }
  const getData = (
    panNo: string,
    accountcategory: any,
    userid: any,
    queryobject?: any,
    skipNavigate?: boolean,
  ) => {
    AGetClientDetailsByPan(
      (res: any) => {
        searchByLeadId(res, queryobject, skipNavigate);
      },
      panNo,
      accountcategory,
      userid
    );
  };

  React.useEffect(() => {
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    console.log(GlobalStore.applicationID, "glo works");
    console.log(clientPartialDetails_ao.applicationId, "local works");
    if (
      (GlobalStore.applicationID !== "" ||
        clientPartialDetails_ao.applicationId) &&
      !(type !== null && type !== undefined && type !== "")
    ) {
      if (
        props.isSubmissionRoute !== undefined &&
        props?.isSubmissionRoute !== null &&
        props?.isSubmissionRoute
      ) {
      } else {
        if (
          props?.skipOption !== undefined &&
          props?.skipOption !== null &&
          props?.skipOption
        ) {
        } else {
          console.log("Submission", props?.isSubmissionRoute);
          AGetStageCompletionStatus(
            (res: any) => getClientStageDetails(res),
            GlobalStore.applicationID || clientPartialDetails_ao.applicationId
          );
        }
      }
    }
    if (
      skipUrl !== "" &&
      skipUrl !== undefined &&
      skipUrl?.toLowerCase() == "yes"
    ) {
    } else if (type !== null && type !== undefined && type !== "") {
      if (id !== null && id !== undefined && id !== "" && id?.length > 0) {
        console.log("queryobject", id);
        let queryString = window.atob(id);
        let queryObject2: IDropoffObject = JSON.parse(
          queryString
        ) as IDropoffObject;
        if (
          queryObject2?.Pan !== null &&
          queryObject2?.Pan !== undefined &&
          queryObject2?.Pan !== ""
        ) {
          getData(queryObject2?.Pan, queryObject2?.Ac, queryObject2?.uid);
        }
      }
      // const queryObject = parseQuery(location.search);
      // console.log("QyerObj", decodeURI(queryObject?.id));
    } else {
      if (
        props?.skipOption !== undefined &&
        props?.skipOption !== null &&
        props?.skipOption
      ) {
      } else {
        if (id !== null && id !== undefined && id !== "" && id?.length > 0) {
          let queryString = window.atob(id);
          let queryObject2: IEsignObject = JSON.parse(
            queryString
          ) as IEsignObject;
          if (
            queryObject2?.Applicationid !== null &&
            queryObject2?.Applicationid !== undefined
          ) {
            localStorage.removeItem("isESignSubmitted");

            if (
              queryObject2?.AccountCategory !== null &&
              queryObject2?.AccountCategory !== undefined
            ) {
              if (
                queryObject2?.AccountCategory == 2 &&
                queryObject2.isEsign == "A" &&
                queryObject2?.UserId !== null &&
                queryObject2?.UserId !== undefined &&
                queryObject2.UserId > 0
              ) {
                GlobalStore.applicationID = queryObject2?.Applicationid;
                // history.replace(containerUrl.esignsubmit);
                AGetClientAccountCode(getAccountDetails, GlobalStore.applicationID);
              } else {
                if (
                  queryObject2?.PanNo !== null &&
                  queryObject2?.PanNo !== undefined &&
                  queryObject2?.PanNo !== ""
                ) {
                  if (queryObject2.isEsign === "K") {
                    getData(
                      queryObject2?.PanNo,
                      queryObject2?.AccountCategory,
                      queryObject2?.UserId,
                      queryObject2
                    );
                  } else
                    getData(
                      queryObject2?.PanNo,
                      queryObject2?.AccountCategory,
                      queryObject2?.UserId
                    );
                }
              }
            }
            if (queryObject2.isEsign === "K") {
              if (
                queryObject2?.UserId !== null &&
                queryObject2?.UserId !== undefined &&
                queryObject2.UserId > 0
              ) {
                history.replace(containerUrl.esignsubmit);
              }
            }
          }
        }
      }
    }

    // if (props.isSubmissionRoute && history.action === 'POP')
    //     history.push(redirectToEntryPoint());
    // else {
    //     const queryObject = parseQuery(location.search);
    //     if (queryObject && queryObject.applicationid && !queryObject.type) {
    //         setIsSubmit(true);
    //         if (queryObject.isPOA === 'true')
    //             history.replace(containerUrl.poa);
    //          else if(GlobalStore.stageStatus.isesigncompleted && !GlobalStore.stageStatus.iskraesigncompleted){
    //             history.replace(dashboardUrl.eSign);
    //          }
    //         else
    //             history.replace(containerUrl.submit);
    //     }
    // }
  }, []);
  function getClientStageDetails(res: any) {
    if (!res || res.error) {
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        //set stage api data to GlobalStore

        setStageData(responseObj);

        //check completeness of stages
        if (props.isSubmissionRoute && history.action === "POP") {
          console.log("hereqqq111");
          history.push(redirectToEntryPoint());
        } else {
          const queryObject = parseQuery(location.search);
          if (queryObject && queryObject.applicationid && !queryObject.type) {
            setIsSubmit(true);
            if (queryObject.isPOA === "true") history.replace(containerUrl.poa);
            else if (queryObject.isEsign === "K") {
              history.replace(containerUrl.submit);
            } else if (responseObj.isesigncompleted && !responseObj?.second_esign_req) {
              history.replace(containerUrl.submit);
            } else if (
              queryObject.isEsign === "A" &&
              !responseObj.iskraesigncompleted
            ) {
              history.replace(dashboardUrl.eSign + "?sc=k");
              //history.replace(statusUrl.docVerificationInProgress);
            } else if (responseObj.isesigncompleted && !responseObj?.second_esign_req) {
              history.replace(containerUrl.submit);
            } else if (
              queryObject.isEsign === "A" &&
              responseObj.iskraesigncompleted
            ) {
              history.replace(containerUrl.submit);
            } else if (!queryObject.isEsign) {
              history.replace(dashboardUrl.eSign + "?sc=k");
            }
          } else {
            const quryParams = queryParameter(location.search);
            let id = quryParams.get("id");
            if (
              id !== null &&
              id !== undefined &&
              id !== "" &&
              id?.length > 0
            ) {
              let queryObject2: IEsignObject = JSON.parse(
                window.atob(id)
              ) as IEsignObject;
              if (queryObject2.isPOA === true)
                history.replace(containerUrl.poa);
              else if (
                queryObject2?.AccountCategory !== null &&
                queryObject2?.AccountCategory !== undefined &&
                queryObject2?.AccountCategory == 2
              ) {
                history.replace(containerUrl.submit);
              } else if (queryObject2.isEsign === "K") {
                if (
                  queryObject2?.UserId !== null &&
                  queryObject2?.UserId !== undefined &&
                  queryObject2.UserId > 0
                ) {
                  history.replace(containerUrl.esignsubmit);
                } else history.replace(containerUrl.submit);
              } else if (responseObj.isesigncompleted && !responseObj?.second_esign_req) {
                history.replace(containerUrl.submit);
              } else if (
                queryObject2.isEsign === "A" &&
                !responseObj.iskraesigncompleted
              ) {
                history.replace(dashboardUrl.eSign + "?sc=k");
                //history.replace(statusUrl.docVerificationInProgress);
              } else if (
                queryObject2.isEsign === "A" &&
                responseObj.iskraesigncompleted
              ) {
                history.replace(containerUrl.submit);
              } else if (responseObj.isesigncompleted && !responseObj?.second_esign_req) {
                history.replace(containerUrl.submit);
              } else if (!queryObject2.isEsign) {
                history.replace(dashboardUrl.eSign + "?sc=k");
              }
            }
          }
        }
      }
    }
  }

  function getClientStageDetailsElog(res: any) {
    if (!res || res.error) {
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        if (responseObj?.elog_opted && responseObj?.iskra) {
          history.replace(statusUrl.elogVerificationInProgress);
        } else {
          history.replace(containerUrl.esignsubmit);
        }
      }
    }
  }

  function getAccountDetails(res: any) {
    let queryString = window.atob(id);
    let queryObject2: IEsignObject = JSON.parse(
      queryString
    ) as IEsignObject;
    if (!res || res.error) {
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        console.log("fffffffffffffff", responseObj);
        getData(responseObj?.pan, queryObject2?.AccountCategory, queryObject2.UserId, null, true);
      }
    }
  }

  return (
    <>
      {!isSubmit && (
        <div
          className={
            props?.regOutNewClassName ? props?.regOutNewClassName : "regLayout"
          }
        >
          <EdelLogoCenter
            headerLogoClassName={
              props?.headerLogoClassName
                ? props?.headerLogoClassName
                : "headerLogo"
            }
          />
          {props.children}
        </div>
      )}
    </>
  );
};

export default RegistrationLayout;
